import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Badge, Button, Col, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, FormText, Input, Modal, ModalBody, Spinner, UncontrolledDropdown } from 'reactstrap';
import { BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Icon, RSelect } from '../../../../components/Component';
import ReactDataTable from './ReactDataTable/ReactDataTable';
import { WEBSITE_BASE_URL } from '../../../../config';
import ToastExample from '../../../../helpers/toast';
import Content from '../../../../layout/content/Content';
import Head from '../../../../layout/head/Head';
import { createScratchCard, deleteScratchCard, getAllScratchCards, toggleScratchCard, updateScratchCard } from '../../../../redux/admin/promotion/action';
import { nonActiveFormSubmissionStatus, openFormLoading } from '../../../../redux/common/actions';
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { getAllStoreCategories, getAllStores } from "../../../../redux/admin/store/action";
import { Link } from 'react-router-dom';
import noimage from '../../../../assets/images/noimage.png'
import { Image, Table } from 'antd';
import { ColorRing } from 'react-loader-spinner';

const ScratchCard = () => {
    const dispatch = useDispatch(); //defining dispatch

    //function to get data from backend
    useEffect(() => {
        dispatch(getAllScratchCards()).then((response) => {
            if (response.payload.length > 0) {
                setLoading(false);
            }
        })
        dispatch(getAllStoreCategories());
        dispatch(getAllStores());
    }, []);

    //to store data from application state to a constant
    const getSelectors = (state) => ({
        scratch_cards: state.promotion.scratch_cards,
        store_categories: state.store.store_categories,
        stores: state.store.stores,
        form_loading: state.common.form_loading,
        form_submission_status: state.common.form_submission_status,

    });
    const { store_categories, stores, scratch_cards, form_loading, form_submission_status, } = useSelector(getSelectors);
    const [loading, setLoading] = useState(true);

    const [editingScratchCard, setEditingScratchCard] = useState([]);   //edit category state

    const [deletingScratchCard, setDeletingScratchCard] = useState([]);   //delete category state

    const [formData, setFormData] = useState([]);   //form data state defined

    const [showToast, setShowToast] = useState(false);   //toast state

    const [data, setData] = useState([]);  //data state defined

    const [storeCategoryId, setStoreCategoryId] = useState([]);  //store_category_id
    const [scratchCardTableDatas, setScratchCardTableDatas] = useState([]);  //store_category_id
    const [image, setImage] = useState([]);  // state defined
    //modal state
    const [modal, setModal] = useState({
        edit: false,
        add: false,
        delete: false,
    });

    const getSelectedStores = (stores) => {
        const allStores = [];
        const selectedStores = [];
        const storesIds = [];
        if (modal.edit) {
            editingScratchCard.stores.map((selected_stores) => (
                storesIds.push(selected_stores.id)
            ))
        }
        let selected = stores.forEach((store) => {
            let selected_user = storesIds.includes(store.id)
            if (selected_user) {
                allStores.push(store);
            }

        });

        allStores?.forEach((element) => {
            const dataObj = {
                value: element.id,
                label: element.name,
            };
            selectedStores.push(dataObj);
        });
        return selectedStores;
    };
    const getStoresDropDown = (stores) => {
        const allStores = [];

        stores.forEach((element) => {
            if (storeCategoryId == element.store_category_id) {
                const dataObj = {
                    value: element.id,
                    label: element.name,
                };
                allStores.push(dataObj);
            }
        });
        return allStores;
    };

    //to open add modal
    const openAddModal = () => {
        setEditingScratchCard([]);
        dispatch(nonActiveFormSubmissionStatus());
        setTimeout(() => {
            setModal({ add: true });
        }, 100);
    };

    //to open edit modal
    const openEditModal = (category) => {
        setModal({ edit: true });
        dispatch(nonActiveFormSubmissionStatus());
        setEditingScratchCard(category);
        setStoreCategoryId(category.store_category_id)
    };

    //to open delete modal
    const openDeleteModal = (category) => {
        setModal({ delete: true });
        dispatch(nonActiveFormSubmissionStatus());
        setDeletingScratchCard(category);
    };

    const listStoreCategories = store_categories?.map((store_category) => (
        { value: store_category.id, label: store_category.name }
    ));

    //form validation with yup
    const categorySchema = yup.object({
        name: yup.string().required(),
        quantity: yup.string().required(),
        amount: yup.string().required(),
        store_ids: yup.array(),
        store_category_id: yup.string().required(),

    });

    //form values
    const defaultValues = useMemo(
        () => ({

            id: editingScratchCard?.id || "",
            name: editingScratchCard?.name || "",
            amount: editingScratchCard?.amount || "",
            quantity: editingScratchCard?.quantity || "",
            store_category_id: editingScratchCard?.store_category_id || "",
            store_ids: editingScratchCard?.store_ids || [],
        }),
        [editingScratchCard]
    );
    //form methods
    const methods = useForm({
        resolver: yupResolver(categorySchema),
        defaultValues: defaultValues,
    });

    //useform methods
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
        control
    } = methods;

    //submit function
    const onFormSubmit = (submitData) => {
        dispatch(openFormLoading());
        console.log(submitData, 'submitdata');
        let store_ids = JSON.stringify(submitData?.store_ids);
        const new_data = new FormData();
        new_data.append('id', editingScratchCard?.id);
        new_data.append('name', submitData?.name);
        new_data.append('token', localStorage.getItem('accessToken'));
        if (image) {
            new_data.append('image', image);
        }
        new_data.append('quantity', submitData?.quantity);
        new_data.append('amount', submitData?.amount);
        new_data.append('store_category_id', submitData?.store_category_id);
        new_data.append('store_ids', store_ids);
        if (modal.edit) {
            setTimeout(() => {
                dispatch(updateScratchCard(new_data));
            }, 50);
        } else if (modal.add) {
            dispatch(createScratchCard(new_data));
        } else if (modal.delete) {
            dispatch(deleteScratchCard(deletingScratchCard?.id));
        }
        resetForm();
    };

    // to reset the form
    const resetForm = () => {
        setFormData({
            name: "",
            quantity: "",
            amount: "",
            store_category_id: "",
            storeIds: [],
        });
    };

    //to close modal
    const onFormCancel = () => {
        setModal({ edit: false, add: false, delete: false });
        // document.getElementByClass("invalid").innerHTML = "";
        resetForm();
    };

    //category toggle
    const handleCategoryStatus = (e, id) => {
        dispatch(toggleScratchCard(id));
        setTimeout(() => {
            dispatch(getAllScratchCards());
            setShowToast(true);
        }, 500);

        setTimeout(() => {
            setShowToast(false);
        }, 3000);
    };

    //submit toast
    useEffect(() => {
        if (modal.add == true && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getAllScratchCards());
                setData(scratch_cards);
                setModal({ add: false });
                setShowToast(true);
            }, 500);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }

        if (modal.edit == true && editingScratchCard && form_loading == false && form_submission_status == true) {
            dispatch(getAllScratchCards());
            setData(scratch_cards);
            setModal({ edit: false });
            setShowToast(true);
            reset(defaultValues);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        } else {
            reset(defaultValues);
        }

        if (modal.delete == true && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getAllScratchCards());
                setData(scratch_cards);
                setModal({ delete: false });
                setShowToast(true);
            }, 500);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }
    }, [createScratchCard, form_loading, modal, form_submission_status]);


    const dataTableColumns = [
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: "Image",
            selector: (row) => row.image,
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <Image
                        style={{
                            height: "15vh",
                            width: "15vh",
                            objectFit: 'cover',
                        }}
                        src={row?.image ? row?.image : noimage}
                    />
                </div>
            )
        },
        {
            name: "Quantity",
            selector: (row) => row.quantity,
            sortable: true,
        },
        {
            name: "Amount",
            selector: (row) => row.amount,
            sortable: true,
        },
        {
            name: "Action",
            selector: (row) => row.salary,
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <DropdownTrans row={row} />
                </div>
            )
        },
    ];


    //action dropdown
    const DropdownTrans = ({ row }) => {
        return (
            <UncontrolledDropdown>
                <DropdownToggle tag="a" className="text-soft dropdown-toggle btn btn-icon btn-trigger">
                    <Icon name="more-h"></Icon>
                </DropdownToggle>
                <DropdownMenu right>
                    <ul className="link-list-plain">
                        <li>
                            <DropdownItem tag="a" onClick={() => openEditModal(row)}>
                                <Icon name="pen" />Edit
                            </DropdownItem>
                        </li>
                        <li>
                            <DropdownItem tag="a"
                                onClick={() => openDeleteModal(row)}>
                                <Icon name="trash" />Delete
                            </DropdownItem>
                        </li>
                    </ul>
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    };

    return (
        <React.Fragment>
            {loading ? (
                <Content >
                    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '75vh' }}>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#fcc314', '#fcc314', '#fcc314', '#fcc314', '#fcc314']}
                        />
                    </div>
                </Content>
            ) :
                <React.Fragment>
                    <Head title="ScratchCards"></Head>

                    {/* content */}
                    <Content>
                        <BlockHead size="sm">
                            <BlockBetween>
                                <BlockHeadContent>
                                    <BlockTitle tag="h3" page>
                                        ScratchCards
                                    </BlockTitle>
                                    <BlockDes className="text-soft">
                                        <p>You have total {scratch_cards?.length} scratch cards.</p>
                                    </BlockDes>
                                </BlockHeadContent>
                                <BlockHeadContent>
                                    <div className="toggle-wrap nk-block-tools-toggle">
                                        <ToastExample
                                            show={showToast}
                                        />
                                        <div className="toggle-expand-content">
                                            <ul className="nk-block-tools g-3">
                                                {/* <li>
                                            <a
                                                href="#export"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                }}
                                                className="btn btn-white btn-outline-light"
                                            >
                                                <Icon name="download-cloud"></Icon>
                                                <span>Export</span>
                                            </a>
                                        </li> */}
                                                <li className="nk-block-tools-opt">
                                                    <Link to={'/scratch-cards-winner'} color="primary" className="btn btn-primary" >
                                                        <Icon name="eye"></Icon>
                                                        <span>Winners</span>
                                                    </Link>
                                                </li>
                                                <li className="nk-block-tools-opt">
                                                    <Button color="primary" className="btn-icon"
                                                        onClick={() => openAddModal()}
                                                    >
                                                        <Icon name="plus"></Icon>
                                                    </Button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </BlockHeadContent>
                            </BlockBetween>
                        </BlockHead>
                        <ReactDataTable data={scratch_cards} columns={dataTableColumns} expandableRows pagination />
                    </Content>

                    {/* add and edit modal */}
                    <Modal
                        isOpen={modal.add || modal.edit}
                        toggle={() => setModal({ add: false })}
                        className="modal-dialog-centered"
                        size="lg"
                    >
                        <ModalBody>
                            <a
                                href="#cancel"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    onFormCancel();
                                }}
                                className="close"
                            >
                                <Icon name="cross-sm"></Icon>
                            </a>
                            <div className="p-2">
                                <h5 className="title">{modal.edit ? "Editing ScratchCard - " + editingScratchCard?.name : "Add ScratchCard"}</h5>
                                <div className="mt-4">
                                    <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)} encType="multipart/formData">
                                        <Col md="12">
                                            <FormGroup>
                                                <label className="form-label">ScratchCard Name</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="name"
                                                    placeholder="Enter ScratchCard Name"
                                                    ref={register({ required: "This field is required" })}
                                                />
                                                {errors.name && <span className="invalid">{errors.name.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="12" style={modal.edit ? { display: 'block' } : { display: 'none' }}>
                                            <FormGroup>
                                                <label className="form-label">Current Image </label>
                                                <div className="" id={editingScratchCard.id}>
                                                    {editingScratchCard?.image ?
                                                        <img src={editingScratchCard.image} alt="banner" style={{ objectFit: 'cover', height: '20vh' }} />
                                                        :
                                                        <>
                                                            <img src={noimage} alt="item category" style={{ height: '20vh', }} />
                                                            <span className='m-1' style={{ color: '#330033', fontSize: '9px' }}>No image found</span>
                                                        </>
                                                    }
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" >Image </label>
                                                <input
                                                    className="form-control"
                                                    type="file"
                                                    name="image"
                                                    accept="image/png, image/jpeg, image/jpg"
                                                    onChange={(e) => {
                                                        setImage(e.target.files[0])
                                                    }}
                                                />
                                                {errors.image && <span className="invalid">{errors.image.message}</span>}
                                                <FormText>Upload resolution 500x500 pixel</FormText>
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Quantity</label>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    name="quantity"
                                                    ref={register({
                                                        required: "This field is required",
                                                    })}
                                                    placeholder="Enter Quantity of Cards"
                                                />
                                                {errors.quantity && <span className="invalid">{errors.quantity.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Amount (For Wallet) </label>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    name="amount"
                                                    placeholder="Enter Reward Amount for Wallet"
                                                    ref={register({
                                                        required: "This field is required",
                                                    })}
                                                />
                                                {errors.amount && <span className="invalid">{errors.amount.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Store Category</label>
                                                <div className="form-control-wrap">
                                                    <Controller
                                                        name="store_category_id"
                                                        control={control}
                                                        render={({ onChange, value, ref }) => (
                                                            <RSelect
                                                                options={listStoreCategories}
                                                                onChange={(val) => {
                                                                    onChange(val.value)
                                                                    setStoreCategoryId(val.value)
                                                                }}
                                                                defaultValue={listStoreCategories.find((store_category) => store_category.value === value)}
                                                            />
                                                        )}
                                                        ref={register({ required: "This field is required" })}
                                                    />
                                                    {errors.store_category_id && (
                                                        <span className="invalid" style={{ color: '#e85347', fontSize: '11px', fontStyle: 'italic' }}>Please choose a Store</span>
                                                    )}
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="12"  >
                                            <FormGroup>
                                                <label className="form-label"> Store :</label>
                                                <div className="form-control-wrap">
                                                    <Controller
                                                        name="store_ids"
                                                        control={control}
                                                        render={({ onChange, value }) => (
                                                            <RSelect
                                                                options={getStoresDropDown(stores)}
                                                                isMulti
                                                                onChange={(val) => onChange(val.map((c) => c.value))}
                                                                defaultValue={getSelectedStores(stores)}
                                                            ></RSelect>
                                                        )}
                                                    />
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="12">
                                            <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                                <li>
                                                    <Button type="submit" color="primary" size="lg" className="btn-block">
                                                        {form_loading ? (
                                                            <>
                                                                <Spinner size="sm" color="light" /> {modal.edit ? "Updating ScratchCard" : "Creating New ScratchCard"}
                                                            </>
                                                        ) : (
                                                            <React.Fragment>{modal.edit ? "Update ScratchCard" : "Add New ScratchCard"}</React.Fragment>
                                                        )}
                                                    </Button>
                                                </li>
                                                <li>
                                                    <a href="#cancel" onClick={(ev) => {
                                                        ev.preventDefault();
                                                        onFormCancel();
                                                    }}
                                                        className="link link-light"   >
                                                        Cancel
                                                    </a>
                                                </li>
                                            </ul>
                                        </Col>
                                    </Form>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>

                    {/* delete modal */}
                    <Modal
                        isOpen={modal.delete}
                        toggle={() => setModal({ delete: false })}
                        className="modal-dialog-centered"
                    // size="lg"
                    >
                        <ModalBody className='pt-3 pb-2'>
                            <a
                                href="#cancel"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    onFormCancel();
                                }}
                                className="close"
                            >
                                <Icon name="cross-sm"></Icon>
                            </a>
                            <div className="p-2">
                                <h5 className="title">Delete ScratchCard{' '}
                                    <Badge color="primary">
                                        {deletingScratchCard?.name}
                                    </Badge>
                                    {' '}
                                    ?
                                </h5>
                                <div className='mt-2'>
                                    <span>This Item category will be deleted. Do you really want to delete this category ?</span>
                                </div>
                                <div className="mt-3">
                                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4">
                                        <li>
                                            <Button onClick={(e) => {
                                                e.preventDefault();
                                                onFormSubmit();
                                            }} color="danger" className="px-4 btn-block">
                                                {form_loading ? (
                                                    <>
                                                        <Spinner size="sm" color="light" />Deleting
                                                    </>
                                                ) : (
                                                    <React.Fragment>Delete</React.Fragment>
                                                )}
                                            </Button>
                                        </li>
                                        <li>
                                            <a href="#cancel"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                    onFormCancel();
                                                }}
                                                className="link link-light"
                                            >
                                                Cancel
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>
                </React.Fragment>
            }
        </React.Fragment>
    );
}
export default ScratchCard
